"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardDeltaLabel = void 0;
var React = require("react");
var metrics_engine_1 = require("@tableau/metrics-engine");
var utils_1 = require("../utils");
var ZERO_WIDTH_SPACE = '\u200B';
var CardDeltaLabel = function (props) {
    var _a, _b, _c;
    var delta = props.comparisonDelta;
    if (delta === undefined) {
        return React.createElement("div", { style: comparisonStyle }, ZERO_WIDTH_SPACE);
    }
    var comparisonText = (0, metrics_engine_1.formatComparisonTextForCard)(delta, props.definition, props.formatString, props.status);
    var iconProps = {
        altText: '',
        testId: 'metric-card-delta-label',
        color: (_a = props.color) !== null && _a !== void 0 ? _a : metrics_engine_1.MetricsNeutralColor,
        style: { verticalAlign: 'text-top', marginRight: '4px', marginTop: '1px' },
        size: 14,
    };
    var symbol = (0, utils_1.getIconForLabel)(iconProps, (_b = props.status) !== null && _b !== void 0 ? _b : metrics_engine_1.ThresholdStatus.UNKNOWN, props.definition, delta);
    return (React.createElement("div", { "data-tb-test-id": 'metric-comparison-text', style: __assign(__assign({}, comparisonStyle), { color: (_c = props.color) !== null && _c !== void 0 ? _c : metrics_engine_1.MetricsNeutralColor }), role: 'img', "aria-label": comparisonText.accessibilityText },
        symbol,
        comparisonText.text));
};
exports.CardDeltaLabel = CardDeltaLabel;
var comparisonStyle = {
    fontSize: '14px',
    fontWeight: 'normal',
};
//# sourceMappingURL=CardDeltaLabel.js.map